// This function allow to reference async chunks
__webpack_require__.miniCssF = (chunkId) => {
	// return url for filenames based on template
	return "static/css/" + chunkId + "." + {"40":"a1881f59","399":"a1881f59","466":"1ce39ed7","495":"4891136b","520":"3baa2591","701":"a1881f59","717":"a1881f59"}[chunkId] + ".chunk.css";
};